module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{},"en":{},"it":{},"fr":{}}')
  delete Component.options._Ctor
}
